const transitions = {
  quick: '100ms',
  normal: '250ms',
  slow: '400ms',
};

export default transitions;
